<div class="pageheader">
  <div class="page-title">
    <h1>Azure AD Settings</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'AzureAD_Action_ShowLog'" [title]="'Azure AD Settings log'">
        <app-change-log-link-entity type="AzureAdTenant"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<div class="container container-fixed">
  <div class="row">
    <div class="col-sm-12">

      <h2>Authentication</h2>
      <div class="panel panel-default" [formGroup]="form">
        <div class="panel-body" style="min-height: 90px">

          <fieldset [disabled]="!editMode">

            <div class="flex-row">
              <div class="item">

                <div class="row">

                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="control control-checkbox lg control-form-group">
                        <label>
                          Enable Azure AD
                          <input formControlName="enableAzureAD" type="checkbox" />
                          <i></i>
                        </label>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="row">

                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="control">
                        <label>Client Id</label>
                        <input class="form-control" [class.invalid-state-border]="fcClientId.invalid"
                          formControlName="clientId" [readonly]="!editMode" type="text" />
                          <div [class.invisible]="!fcClientId.invalid || (fcClientId.pristine && fcClientId.untouched)">
                            <span class="error">Client id is required when Azure AD is enabled</span>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="row">

                    <div class="col-md-12">
                      <div class="form-group">
                        <div class="control">
                          <label>Client secret</label>
                          <input class="form-control" [class.invalid-state-border]="fcClientSecret.invalid"
                            formControlName="clientSecret" [readonly]="!editMode" type="password"
                            [attr.placeholder]="hasSecret ? '••• A secret is set •••' : null" />
                            <div
                              [class.invisible]="!fcClientSecret.invalid || (fcClientSecret.pristine && fcClientSecret.untouched)">
                              <span class="error">Client secret is required when Azure AD is enabled</span>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                  <div class="item">

                    <div class="row">
                      <div class="col-sm-12 col-md-9">
                        <div class="form-group">
                          <div class="control control-checkbox lg control-form-group">
                            <label>
                              Enable Link users
                              <input formControlName="enableLinkUser" type="checkbox" />
                              <i></i>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </fieldset>

              <div class="row" *bizPermissionRequired="'AzureAD_Action_Edit'">
                <div class="col-md-12 relative">
                  @if (!editMode) {
                    <button type="button" class="btn btn-primary" (click)="editClicked()">Edit</button>
                  }
                  @if (editMode) {
                    <button type="button" class="btn btn-primary" (click)="saveClicked()"
                    [disabled]="form.invalid">Save</button>
                  }
                  @if (editMode) {
                    <button type="button" class="btn btn-link" (click)="cancelClicked()">cancel</button>
                  }
                  @if (editMode) {
                    <p class="absolute-center">You cannot disable the authentication type that you are
                    currently using</p>
                  }
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <hr />

    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">

          <h2>Azure AD Tenants</h2>
          <dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='tenants' [bizSetColumnChooser]="false"
            [bizSetAllowColumnReordering]="false" [bizSetSearchPanel]="false" [bizSetPager]="false"
            (onInitNewRow)="onInitNewRow($event)"
            (onRowUpdating)="onRowUpdating($event)"
            (onRowInserting)="onRowInserting($event)"
            (onRowRemoving)="onRowRemoving($event)"
            >

            <dxo-editing mode="row" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding"
              [allowDeleting]="allowDeleting">
              <dxo-popup title="Azure AD Tenants" [showTitle]="true"></dxo-popup>
            </dxo-editing>

            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

            <dxi-column dataField="Name" caption="Name" dataType="string">
              <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-column>

            <dxi-column dataField="TenantId" caption="Tenant Id" dataType="string" sortOrder="asc">
              <dxi-validation-rule type="required"></dxi-validation-rule>
              <dxi-validation-rule type="pattern" pattern="^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$" message="Invalid Tenant ID - Must be a valid GUID"></dxi-validation-rule>
            </dxi-column>

            <dxi-column dataField="Approved" caption="Approved" dataType="boolean">
            </dxi-column>


          </dx-data-grid>

        </div>
      </div>
    </div>
